import { OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SummaryService } from '../services/summary.service';
import { TokenManager } from '../Globals';
import { Globals } from '../objects/Globals';
import { Location } from '@angular/common';
import { BsModalService } from 'ngx-bootstrap/modal';
var LayoutCatalogueComponent = /** @class */ (function () {
    function LayoutCatalogueComponent(route, globals, location, router, summaryService, tokenManager, modalService) {
        this.route = route;
        this.globals = globals;
        this.router = router;
        this.summaryService = summaryService;
        this.tokenManager = tokenManager;
        this.modalService = modalService;
        this.forceRefreshDetail = true;
        this.smallPad = false;
        this.searchKeyword = '';
        this.isProductDetail = false;
        this.location = location;
    }
    LayoutCatalogueComponent.prototype.onCartSet = function (cartComponentId) {
        this.cartComponentId = cartComponentId;
        // this.summaryService.createSummaryWithParent(this.catalogueType, this.catalogueSummary, this.cartComponentId).subscribe(result=>{
        //   this.catalogueComponentId = result;
        // });
    };
    LayoutCatalogueComponent.prototype.onResize = function (event) {
        if (event.target.innerWidth < 992) {
            this.smallPad = true;
        }
        else {
            this.smallPad = false;
        }
    };
    LayoutCatalogueComponent.prototype.toggleSidebar = function (showView) {
        if (showView) {
            this.smallPad = false;
        }
        else {
            this.smallPad = true;
        }
    };
    LayoutCatalogueComponent.prototype.onSearchKeywordChange = function (keyword) {
        this.searchKeyword = keyword;
    };
    LayoutCatalogueComponent.prototype.updateCards = function (event) {
        this.forceRefreshDetail = !this.forceRefreshDetail;
    };
    LayoutCatalogueComponent.prototype.updateTotalRows = function (event) {
        this.noOfItems = event;
    };
    LayoutCatalogueComponent.prototype.showCart = function (template) {
        this.modalRef = this.modalService.show(template, { class: 'modal-dialog-centered modal-cart', ignoreBackdropClick: true });
    };
    LayoutCatalogueComponent.prototype.setSummaryName = function ($event) {
        this.summaryName = $event;
    };
    LayoutCatalogueComponent.prototype.onDecline = function () {
        this.modalRef.hide();
    };
    LayoutCatalogueComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.smallPad = (window.innerWidth) < 992;
        this.tokenManager.store("BRNCurrentRoute", this.router.url);
        if (this.globals.Session == null) {
            this.router.navigate(['/', '/']);
        }
        ;
        this.cartComponentId = this.route.snapshot.paramMap.get('cartId');
        this.catalogueComponentId = this.route.snapshot.paramMap.get('summaryId');
        if (this.catalogueComponentId && this.globals.Session) {
            this.summaryService.getCurrentSearchKeyword(this.catalogueComponentId).subscribe(function (result) {
                if (result) {
                    _this.searchKeyword = result;
                }
                else {
                    _this.searchKeyword = "";
                }
            });
        }
    };
    LayoutCatalogueComponent.prototype.onSelectedItem = function (selectedId) {
        this.isProductDetail = true;
        this.selectedProductDetailId = selectedId;
    };
    return LayoutCatalogueComponent;
}());
export { LayoutCatalogueComponent };
